import { useMutation } from "@tanstack/react-query";
import { adminSignUp } from "@/api/v1-jwt/tenancy/tenancy";

export const useAdminSignup = () => {
  return useMutation({
    mutationFn: adminSignUp,
  });
};
